import { render, staticRenderFns } from "./beca-registro-extranjera.vue?vue&type=template&id=569a955f&"
import script from "./beca-registro-extranjera.component.ts?vue&type=script&lang=ts&"
export * from "./beca-registro-extranjera.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports